import type { FrequentlyOrderProduct } from '~/api/model';
import { LuckyDiscountedPrice } from '~/app/common/components/Product/ProductPrice/LuckyDiscountedPrice';
import { MembershipDiscountedPrice } from '~/app/common/components/Product/ProductPrice/MembershipDiscountedPrice';
import type { StyleableProps } from '~/types';

import { CouponDiscountedPrice } from '~/app/common/components/Product/ProductPrice/CouponDiscountedPrice';
import { MembershipStandardNudgeProductPrice } from '~/app/common/components/Product/ProductPrice/MembershipStandardNudgeProductPrice';
import { RegularProductPrice } from '~/app/common/components/Product/ProductPrice/RegularProductPrice';
import { useProductPriceVariant } from '~/app/common/components/Product/ProductPrice/useProductPriceVariant';

// TODO: reverse props 제거할 것
export type ProductPriceProps = FrequentlyOrderProduct & {
  reverse?: boolean;
  wFull?: boolean;
  is3x2?: boolean;
} & StyleableProps;

export function ProductPrice(data: ProductPriceProps) {
  const variant = useProductPriceVariant(data);

  switch (variant) {
    case 'membershipWeek':
      return <MembershipDiscountedPrice {...data} />;
    case 'luckyBonusPack':
      return <LuckyDiscountedPrice {...data} />;
    case 'membershipStandardNudge':
      return <MembershipStandardNudgeProductPrice {...data} />;
    case 'couponDiscounted':
      return <CouponDiscountedPrice {...data} />;
    case 'noDiscount':
      return <RegularProductPrice {...data} />;
    default:
      return null;
  }
}
